import { checkIsClientView } from '~/apis/auth';

const BROWSER_BRAND_ID_STORAGE_KEY = 'selected_brand_id';
const _getStorageByEnv = () => (checkIsClientView() ? sessionStorage : localStorage);

export const getStorageBrandId = () => {
  const storage = _getStorageByEnv();
  const stringSelectedBrandId = storage.getItem(BROWSER_BRAND_ID_STORAGE_KEY);
  const selectedBrandId = stringSelectedBrandId ? Number(stringSelectedBrandId) : undefined;

  return selectedBrandId;
};

export const updateStorageBrandId = (brandId?: number) => {
  const storage = _getStorageByEnv();
  const selectedBrandId = getStorageBrandId();

  if (!brandId) {
    clearStorageBrandId();
  }
  if (selectedBrandId === brandId) return;
  storage.setItem(BROWSER_BRAND_ID_STORAGE_KEY, String(brandId));
};

export const clearStorageBrandId = () => {
  const storage = _getStorageByEnv();
  storage.removeItem(BROWSER_BRAND_ID_STORAGE_KEY);
};
